module.exports = __webpack_public_path__ + "media/images/venues-share-65f532c567022ad458eb023833f88de8.jpg";